import { render } from "./ModalTableReserved.vue?vue&type=template&id=7bcd38ef"
import script from "./ModalTableReserved.vue?vue&type=script&lang=js"
export * from "./ModalTableReserved.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__